<template>
    <section class="topbarchart">
        <div v-for="d in data" class="caption" :key="d.key + 'caption'">
            {{d.key}}
        </div> 
        
        <div v-for="(d, index) in data" class="row" :key="d.key + 'row'"> 
            

            <div v-for="(value, p) in d.params" 
                :key="p" :class="`param param-${p}`"
                :style="{width: x(value)+'%'}"
            >
                <span class='text'> {{value}} </span>

                <div v-if="params && index===0" class="legend-caption tiny-text">{{params[p]}}</div>
            </div> 
        </div>
        
    </section>
</template>


<script>

import * as d3 from 'd3'

export default {
    name: "top-chart",
    props: {
        data: Array,
        params: Object,
    },

    computed: {
        x() {
            return d3.scaleLinear()
                .domain([0, this.data[0].params.total])
                .range([0, 100])
        }
    },

    // mounted() {
        // this.$nextTick(() =>
        //     tippy(this.$el.querySelectorAll('.row'), {
        //         duration: 0, 
        //         arrow: false
        //     })
        // )
    // },
}
</script>

<style lang="scss" scoped>

.topbarchart {
    margin-top: 1.5em;
    display: grid;
    grid-template-rows: repeat(1fr);
    grid-row-gap: 0.8rem;

    grid-template-columns: [start] min-content [middle] 2fr [end];
    grid-column-gap: 0.6rem;
    grid-auto-flow: column;
}

$height: 1.3rem;

.row {
    grid-column: middle/end;
    height: $height;
    border-radius: 0.25 * $height;
    position: relative;
    cursor: pointer;
    font-size: 12px;

    .param {
        height: $height;
        border-radius: 0.25 * $height;
        position: absolute;
    }

    .text {
        position: absolute;
        right: 0.3em;
        line-height: $height;
    }
}

.caption {
    line-height: 0.9rem;
    // height: $height;
    font-size: 12px;
    grid-column: start/middle;
    text-align: left;
    overflow: hidden;
    cursor: pointer;
    min-width: 17em;


    // &:hover {
        //     overflow: visible;
    //     background-color: white;
    //     z-index: 100;
    // } 
}


.legend-caption {
    position: absolute;
    right: 0.3em;
    top: -$height - 0.2rem;
    color: black;
    cursor: initial;

}
@media screen and (max-width: 500px){
    .caption {
        min-width: unset;
    }
}

@media screen and (max-width: 800px){
    .row .text {
        font-size: 10px;
    }
}
</style>